import { render, staticRenderFns } from "./ValidationPage.vue?vue&type=template&id=59156206"
import script from "./ValidationPage.vue?vue&type=script&lang=js"
export * from "./ValidationPage.vue?vue&type=script&lang=js"
import style0 from "./ValidationPage.vue?vue&type=style&index=0&id=59156206&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports